import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { CONSULTATION_TYPES, URLS } from 'src/app/constant/constant';
import { reportspdf, pharmacies } from 'src/app/models/reportspdf';
import { DateUtilService, moment_duration } from '../../../utilities/date.util.service';
import { UtilitiesService } from '../../../utilities/utilities.service';
import { PatientService } from '../../../services/patient.service';
import { ApiResult, PromiseResult, ServerError } from '../../../models/PromiseResult';
import { ROLES } from 'src/app/constant/constant';
import { TokenService } from 'src/app/utilities/token.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

// interface pharmacy
// {
//     pharmacy_id: number;
//     pharmacy_name: string;
//     address_line1: string;
//     address_line2: string;
//     zip_code: number;
//     phone_number: number;
//     state_name: string;
//     country_name: string;
// }

@Component({
    selector: 'app-prescription-details',
    templateUrl: './prescription-details.component.html',
    styleUrls: [
        './../../../../assets/css/custom-egd-1.css',
        '../../../../assets/css/custom-egd.css',
        './prescription-details.component.css'
    ]
})
@TraceClassDecorator()
export class PrescriptionDetailsComponent implements OnInit {
    @Input() data: reportspdf;
    @Input() dataId: string;
    @Input() patient_id: string;


    page;
    logo_url: string = "";
    gender: string = '';
    dob: string = '';
    doctor_name = '';
    specialty = '';
    response: PromiseResult;
    serverError: ServerError;
    con_id: number;
    currentrole: number;
    is_primary_provider: boolean = false;
    is_patient_role: boolean;
    // pharmacy_details: pharmacy[] = [];
    country_name: string;
    isCountryIndia: boolean = false;
    isNutritionalPrescription: boolean = false;
    isGeorgiaPrescription: boolean = false;
    gmc_reg_no: string = "";
    pharmacies: pharmacies[] = [];
    is_uk_country: boolean = false;
    constructor(
        private readonly utils: UtilitiesService,
        private readonly dateUtil: DateUtilService,
        private readonly patientservice: PatientService,
        private readonly tokenUtil: TokenService,
        private readonly providerStateService: ProviderStateService

    ) { }

    async ngOnInit(): Promise<void> {
        this.is_primary_provider = this.providerStateService.getIsPrimaryProvider();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.isNutritionalPrescription = this.data.consultation.consultation_type_id == CONSULTATION_TYPES.NUTRITION_AND_HEALTH_CONSULTATION;
        this.con_id = this.data.consultation.id;
        const dage = this.dateUtil.diff(new Date(this.data.patient.date_of_birth), new Date(), moment_duration.years);
        const age = dage + ' Yrs';
        this.page = age;
        this.logo_url = this.data.logoUrl;
        this.gender = this.data.patient.gender;
        this.country_name = this.data.patient.country.country_name;
        this.gmc_reg_no = this.data.consultation.p_consultation_appointment.map((d) => {
            return d.egd_users.doctor_profile.gmc_reg_no
        })
            .join(', ');
        this.doctor_name = this.data.consultation.p_consultation_appointment
            .map((d) => {
                return d.egd_users.first_name + ' ' + d.egd_users.last_name;
            })
            .join(', ');
        this.specialty = this.data.consultation.p_consultation_appointment
            .map((d) => {
                return d.d_specialty_type.specialty_name;
            })
            .join(', ');
        this.gender =
            this.gender[0].toUpperCase() + this.gender.substr(1).toLowerCase();

        this.currentrole =
            this.tokenUtil.findRoleId();
        if (
            this.currentrole == ROLES.Patient
        ) {
            this.is_patient_role = true;
        }
        if (this.patient_id && this.is_patient_role) {
            await this.GetPharmacy();
        }

    }

    DateFormat(date: Date): string {
        return formatDate(date, 'fullDate', 'en-us');
    }
    titleCase(data: string) {
        return this.utils.titlecase(data);
    }
    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }
    result: PromiseResult;
    async GetPharmacy(): Promise<void> {
        await this.patientservice
            .GetPharmacyData(this.patient_id, this.con_id)
            .toPromise()
            .then((result: PromiseResult) => {
                this.result = result;
                this.isGeorgiaPrescription = result.success;
                if (result.success) {
                    this.pharmacies = result.data.pharmacy_data;
                }

            });

    }

    // async GetPharmacy() {
    //     this.ResetResultModels();

    //     await this.patientservice
    //         .GetPharmacyData(this.patient_id,this.con_id)
    //         .toPromise()
    //         .then((result: PromiseResult) => {
    //             this.result = result;
    //             let temp: pharmacy[] = [];
    //             if (result.success) {
    //                 if (this.result.data.length > 0) {

    //                         temp.push({

    //                             pharmacy_id :this.result.data.pharmacy_data.pharmacy_id,
    //                             pharmacy_name :this.result.data.pharmacy_data.pharmacy_name,
    //                             address_line1 :this.result.data.pharmacy_data.address_line1,
    //                             address_line2 :this.result.data.pharmacy_data.address_line2,
    //                             zip_code :this.result.data.pharmacy_data.zip_code,
    //                             phone_number :this.result.data.pharmacy_data.phone_number,
    //                             state_name :this.result.data.pharmacy_data.country_states.state_name,
    //                             country_name :this.result.data.pharmacy_data.country.country_name

    //                         });


    //                 }
    //             }
    //             this.pharmacy_details = temp;
    //             this.isGeorgiaPrescription = true;
    //         });

    // }

}
